'use client';
import { Box, DialogContent, DialogTitle, Drawer, ModalClose, useBreakpoints } from '@castlery/fortress';
import { typographyV2 } from '@castlery/fortress/Theme/v2/typography';

interface PropertyExplanationDrawerProps {
  open: boolean;
  onClose: () => void;
  explanation?: string;
}

export const PropertyExplanationDrawer = (props: PropertyExplanationDrawerProps) => {
  const { open, onClose, explanation } = props;
  const { desktop } = useBreakpoints();

  if (!explanation) {
    return null;
  }

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor={desktop ? 'right' : 'bottom'}
      size="md"
      sx={{
        ...(!desktop && {
          '--Drawer-verticalSize': '80vh',
        }),
      }}
    >
      {/* <DialogTitle>
        <ModalClose />
      </DialogTitle> */}
      <ModalClose
        sx={{
          '&.MuiModalClose-root': {
            zIndex: '10 !important',
            cursor: 'pointer',
          },
        }}
      />
      <DialogContent>
        <Box
          px={6}
          dangerouslySetInnerHTML={{ __html: explanation }}
          sx={(theme) => ({
            ...theme.typography,
            strong: {
              ...theme.typography.h5,
            },
            b: {
              ...theme.typography.h5,
            },
            ul: {
              ...theme.typography.body2,
            },
            li: {
              ...theme.typography.body2,
            },
            p: {
              ...theme.typography.body2,
            },
            a: {
              textDecorationColor: 'var(--fortress-palette-warning-500) !important',
            },
          })}
        />
      </DialogContent>
    </Drawer>
  );
};
